import { useCallback } from 'react'
import { useDaumPostcodePopup } from 'react-daum-postcode'
import { toast } from 'react-toastify'
import i18n from '@/locales/i18n.ts'
import { geocodeAddress } from '@/util/geocode.ts'

export interface IAddressSearchResult {
    address: string
    latitude: number
    longitude: number
}

const buildFullAddress = (data: any): string => {
    if (data.addressType !== 'R') return data.address

    const extras = [data.bname, data.buildingName].filter(
        (value: string) => typeof value === 'string' && value !== ''
    )

    return extras.length > 0 ? `${data.address} (${extras.join(', ')})` : data.address
}

const useAddressSearch = (onSelected: (result: IAddressSearchResult) => void) => {
    const open = useDaumPostcodePopup()

    const openAddressSearch = useCallback(() => {
        open({
            onComplete: async (data: any) => {
                const address = buildFullAddress(data)
                try {
                    const { latitude, longitude } = await geocodeAddress(address)
                    onSelected({ address, latitude, longitude })
                } catch (error) {
                    toast.error(
                        error instanceof Error ? error.message : i18n.t('geocode.error.failed'),
                        { toastId: 'address-geocode-failed' }
                    )
                }
            }
        })
    }, [open, onSelected])

    return { openAddressSearch }
}

export default useAddressSearch
